package services

import kotlinx.browser.window

class BrowserLocalStorageStore(private val key: String) : MetricsStore {
    override fun read(): String = window.localStorage.getItem(key).orEmpty()

    override fun write(value: String) {
        window.localStorage.setItem(key, value)
    }

    override fun clear() {
        window.localStorage.removeItem(key)
    }
}
